module.exports = __webpack_public_path__ + "static/media/termsHero.03b8a89f.jpg";